module.exports = __webpack_public_path__ + "2a5615d8e0ba269cf65c6024c32db9a7.png";